import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const CustomerVisitList = Loadable(lazy(() => import("./CustomerVisitList")));

const customerVisitRoutes = [
  {
    path: "/CustomerVisit/CustomerVisitList",
    element: <CustomerVisitList />,
    permission: PERMISSIONS.CustomerVisits.Menu,
  },
];
export default customerVisitRoutes;
